import AnimateHeight from 'react-animate-height'
import { useTranslation } from 'react-i18next'
import { ConsentFormTemplate } from '@lmc/common/types'
import { LabelTextBox } from '@lmc/ui-kit'
import { isBrowser, isTablet } from 'react-device-detect'
import { Resident } from '@lmc/ts-common'

type TextEditorProps = {
  isSelected: boolean
  item: ConsentFormTemplate
  resident: Resident
  handleEditForm?: (id: string) => void
  handleCancelEditForm?: (id: string) => void
  setCopyOfTemplates?: any
  copyOfTemplates?: any[]
  customEntry?: boolean
}

const TextEditor = ({
  isSelected,
  item,
  resident,
  handleCancelEditForm,
  handleEditForm,
  setCopyOfTemplates,
  copyOfTemplates,
  customEntry
}: TextEditorProps) => {
  const { t } = useTranslation()

  const translate = (key: string, variable?: any) =>
    t(`consent.createConsentForms.components.consentModal.${key}`, variable)

  const labelTextBoxTranslate = (key: string, variable?: any) =>
    t(`components.labelTextBox.${key}`, variable)

  const isMobile = !isBrowser && !isTablet

  const content = typeof item?.body === 'string' ? item?.body : ''

  const contentWithNames = content
    .replaceAll('{name}', resident?.preferredName || resident?.name?.first)
    .replaceAll('{resident}', resident?.preferredName || resident?.name?.first)

  return (
    <AnimateHeight
      animateOpacity
      duration={300}
      height={isSelected ? 'auto' : 0}
    >
      <LabelTextBox
        isMobile={isMobile}
        key={item.id}
        style={{ marginTop: 50 }}
        localisation={{
          title: item.title,
          subTitle: translate('statement', {
            variable: resident?.preferredName || resident?.name?.first
          }),
          readOnly: labelTextBoxTranslate('readOnly'),
          save: t('general.buttons.save'),
          cancel: t('general.buttons.cancel'),
          clickToAddTitle: translate('clickToAddTitle'),
          loseText: labelTextBoxTranslate('loseText')
        }}
        content={contentWithNames}
        state="display"
        onEdit={() => handleEditForm?.(item.id)}
        onCancel={() => handleCancelEditForm?.(item.id)}
        id={item.id}
        setCopyOfTemplates={setCopyOfTemplates}
        copyOfTemplates={copyOfTemplates}
        customEntry={customEntry}
      />
    </AnimateHeight>
  )
}

export default TextEditor
